export const base = '/knowledge_base/:knowledgeId?';